import { useQuery } from "@msuite/ui/query";
import { responseHandler } from "@msuite/ui/utils";
import { guardString } from "@msuite/utils/strings";
import type { Nullable } from "@msuite/utils/types";
import { client } from "@/hono";

/** One return run, with its project and the trucks fetching it. */
export function useReturnOrder(returnOrderId: Nullable<string>) {
	/** Query */
	const query = useQuery({
		queryKey: ["return-order", guardString(returnOrderId)],
		queryFn: async () => {
			const response = await client.stock["return-orders"][":returnOrderId"].$get({
				param: { returnOrderId: guardString(returnOrderId) },
			});
			// Suppressed like `useOrder`: the page renders the refusal itself.
			const data = await responseHandler(response, false);
			return data.returnOrder;
		},
		enabled: !!returnOrderId,
	});

	/** Return */
	return { ...query, returnOrder: query.data };
}
